import React, { useEffect, useCallback, useState } from "react";
import { employeeMngtThunk } from "../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

export const ReportDisciplinary = () => {
  const { disciplinaryCases } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();
  const [searchCases, setSearchCases] = useState("");
  const { isLoading, message, updateLoader } = useLoadingMessage();

  console.log("dis", disciplinaryCases);

  const getDiciplinaryCase = useCallback(async () => {
    await dispatch(employeeMngtThunk.getDiciplinaryCases());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getDiciplinaryCase();
  }, []);

  const AllCases = disciplinaryCases.filter((cases) => {
    return (
      cases.disciplinary_id &&
      cases.disciplinary_id.name
        .toLowerCase()
        .indexOf(searchCases.toLowerCase()) !== -1
    );
  });
  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box-two">
                  <h4 className="page-title"></h4>
                  <h1 className="welcome_text">REPORT MANAGEMENT</h1>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className=" table-responsive">
                  <div className="table-title">
                    <div className="row">
                      <div className="col-sm-6">
                        <h2>
                          <b> DISCIPLINARY CASE SUMMARY</b>{" "}
                        </h2>
                      </div>
                      <div class="col-sm-6">
                        <Link to="/dashboard/report" className="btn  p-3">
                          <span class="fa fa-arrow-left"></span>&nbsp;Back&nbsp;
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-xs-12">
                      <div className="">
                        <div className="mb-3 clearfix">
                          <div
                            class="btn-group float-left"
                            role="group"
                            aria-label="Basic example"
                          >
                            <button
                              type="button"
                              class="btn btn-secondary btn-group-sm"
                              onClick={() => window.print()}
                            >
                              Print
                            </button>
                            <ReactHTMLTableToExcel
                              id="test-table-xls-button"
                              className="btn btn-secondary btn-group-sm"
                              table="report-disciplinary"
                              filename="DISCIPLINARY SUMMARY"
                              sheet="tablexls"
                              buttonText="Export to excel"
                            />
                          </div>

                          <form class="form-inline my-2 my-lg-0 float-right">
                            <input
                              class="form-control mr-sm-2"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              name="search"
                              value={searchCases}
                              onChange={(e) => setSearchCases(e.target.value)}
                            />
                          </form>
                        </div>
                      </div>
                      <div className="" id="printTable">
                        <table
                          className="table table-striped table-hover learn-table"
                          id="report-disciplinary"
                        >
                          {AllCases < 1 ? (
                            <div className="text-center m-auto">
                              <h1 className="text-dark">No record found</h1>
                            </div>
                          ) : (
                            <thead>
                              <tr>
                                <th className="th-sm">
                                  <b> S/N </b>
                                </th>
                                <th className="th-sm">
                                  <b> NAME </b>
                                </th>
                                <th className="th-sm">
                                  <b> OPENED BY </b>
                                </th>
                                <th className="th-sm">
                                  <b> OPENED FOR </b>
                                </th>
                                <th className="th-sm">
                                  <b> PENALTY </b>
                                </th>
                                <th className="th-sm">
                                  <b> STATUS </b>
                                </th>
                              </tr>
                            </thead>
                          )}
                          <tbody>
                            {AllCases.map((disciplinary, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{disciplinary.disciplinary_id.name}</td>
                                <td>{disciplinary.assigned_by.first_name}</td>
                                <td>{disciplinary.assigned_to.first_name}</td>
                                <td>{disciplinary.penalty}</td>
                                <td>
                                  {disciplinary.status === 1 ? (
                                    <div>
                                      <span className="status text-success">
                                        &bull;
                                      </span>
                                      Open
                                    </div>
                                  ) : (
                                    <div>
                                      <span className="status text-danger">
                                        &bull;
                                      </span>{" "}
                                      Closed
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/reportmanagement/disciplinary_case_list.js